export const DEFAULT_TIME = '0:00';
